import { ChangeDetectionStrategy, Component, Input, OnChanges, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HisHtmlUtils } from '../../core/utils';

/**
 * Filtert HTML-Inhalte mit HIS-eigenem Filter, statt dem Angular DOMSanitizer und zeigt diese in einem div Container an.
 */
@Component( {
    selector: 'his-safe-html',
    templateUrl: './his-display-safe-html.component.html',
    standalone: true, // Standalone aktivieren
    changeDetection: ChangeDetectionStrategy.OnPush // Optional: ChangeDetection-Strategie
} )
export class HisSafeHtmlComponent implements OnChanges {
    private readonly ds = inject(DomSanitizer);

    @Input() language: string;
    @Input() allowedContentMode: string = 'default';    // 'default', 'tagsOnly', 'onPaste', extendedHtml with defined allowed Tag and Attributes
    @Input() allowedHtmlTags: string | null = '';
    @Input() allowedHtmlAttributes: Array<string> | null = [];
    @Input() html: string | null = '';
    @Input() maxLength: number | null = null; // if set, the html content will be shortened to this length
    filteredHtml: string | null = null; // filtered html content
    trusted: SafeHtml = '';

    ngOnChanges(): void {
        const v = this.html ?? '';
        const filteredHTml = HisHtmlUtils.filterHtml( v, this.allowedContentMode, this.allowedHtmlTags, this.allowedHtmlAttributes );
        if ( this.maxLength && this.maxLength > 0 ) {
            this.filteredHtml = HisHtmlUtils.shortenHtmlByContentMaxLimit( filteredHTml, this.maxLength );
        } else {
            this.filteredHtml = filteredHTml;
        }
        this.trusted = this.ds.bypassSecurityTrustHtml( this.filteredHtml );
    }
}